export enum VariableTypeEnum {
	InsurerList = 1,
	BodyShopList = 2,
	SupplierList = 3,
	MakeList = 4,
	ModelList = 5,
	SubModelList = 6,
	VehicleYearList = 7,
	CountryList = 8,
	Boolean = 9,
	OrderStatusList = 10,
	FreeText = 11,
	FreeInteger = 12,
	FreeDecimal = 13,
	Date = 14,
	DateRange = 15,
	StatesList = 16,
}
